import { cn } from "../../../utils/formatting";
import DesktopSidebarDashboardButtons from "./DesktopSidebarDashboard";

const DesktopSidebar = ({ className }) => {

  return (
    <div
      className={cn(
        "flex flex-col justify-between h-[100vh] overflow-y-auto w-[300px] py-3 px-2 border-r-2 border-slate-200",
        className,
      )}
    >
      <div>
        <a className="flex items-cente px-6" href="/home">
          <img src="/images/nhwm.png" alt="Logo" className="size-12 mr-3" />
          <span className="font-bold text-2xl flex items-center">NHWM</span>
        </a>
        <div className="flex flex-col mt-5 gap-y-3 ">
          <DesktopSidebarDashboardButtons />
        </div>
      </div>
      <div className="flex flex-col items-center justify-center p-4">
        <p className="mb-1 text-sm text-[#307bc4] text-center">
          Need any Assistance?
        </p>
        <p className="mb-1 text-sm text-[#307bc4] text-center">Contact Us:</p>
        <p className="mb-1 text-sm text-[#307bc4] text-center">
          <a href="tel:+913614516663">+91 3614516663 (Call)</a>
        </p>
        <p className="mb-1 text-sm text-[#307bc4] text-center">
          <a href="tel:+913614516663">+91 9707076232 (WA and Call)</a>
        </p>
        <p className="mb-1 text-sm text-[#307bc4] text-center">
          <a href="tel:+913614516663">+91 9707998887 (WA and Call)</a>
        </p>
      </div>
    </div>
  );
};

export default DesktopSidebar;
